import { createApi } from '@reduxjs/toolkit/query/react';
import { waServicesQuery } from './baseQueries';
import { WARootState } from './store';

export type FinancialInstitutionCategory =
  | 'Bank'
  | 'Credit Card'
  | 'Investment'
  | 'Insurance'
  | 'Loan';
export interface FinancialInstitution {
  FinancialInstitutionId: number;
  AggregatorId: number;
  InstitutionId: number;
  Name: string;
  Categories: FinancialInstitutionCategory[];
  UserLoginUrl: string;
  IsPopular: boolean;
  IsDisabled: boolean;
  DisabledMessage: string | null;
  BaseUrl: string;
}

interface FinancialInstitutionsResponse {
  Records: FinancialInstitution[];
  TotalLength: number;
}

export const financialInstitutionsApi = createApi({
  reducerPath: 'financialInstitutionsApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    searchFinancialInstitutions: builder.query<
      FinancialInstitutionsResponse,
      { searchTerm: string; page?: number; limit?: number }
    >({
      queryFn: async (
        { searchTerm, page = 1, limit = 100 },
        { getState },
        _extra,
        baseQuery,
      ) => {
        const state = getState() as WARootState;
        const currentRole = state.auth.currentRole;

        const result = await baseQuery({
          url: `/api/${String(currentRole)}/financialInstitutions?limit=${limit.toString()}&searchTerm=${encodeURIComponent(
            searchTerm,
          )}&page=${page.toString()}`,
        });

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as FinancialInstitutionsResponse };
      },
    }),
  }),
});

export const { useSearchFinancialInstitutionsQuery } = financialInstitutionsApi;
